
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('ContactForm');
    const submitButton = document.getElementById('ContactForm-submit');
    const requiredFields = form.querySelectorAll('[required]');
    const emailField = form.querySelector('input[type="email"]');
    const emailError = document.getElementById('ContactForm-email-error');

    function validateEmail(email) {
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      return emailPattern.test(email);
    }

    function validateForm() {
      let allValid = true;
      requiredFields.forEach(field => {
        if (!field.value.trim()) {
          allValid = false;
        }
      });

      if (!validateEmail(emailField.value)) {
        allValid = false;
        if (emailError) {
          emailError.style.display = 'block';
        }
      } else {
        if (emailError) {
          emailError.style.display = 'none';
        }
      }

      submitButton.disabled = !allValid;
      if (allValid) {
        submitButton.classList.remove('disable');
      } else {
        submitButton.classList.add('disable');
      }
    }

    requiredFields.forEach(field => {
      field.addEventListener('input', validateForm);
    });

    validateForm(); // Initial validation
  });

